import { pick } from 'lodash-es';

import type { User } from '../entities/model';
import type { CommonUserRow } from './types';

export const mapUserToCommonUserRow = (user: User): CommonUserRow =>
  pick(user, ['id', 'email', 'metadata', 'lastActive', 'inviteStatus']);
